import { render, staticRenderFns } from "./IndividualsPage.vue?vue&type=template&id=00339e8b&scoped=true&"
import script from "./IndividualsPage.vue?vue&type=script&lang=js&"
export * from "./IndividualsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00339e8b",
  null
  
)

export default component.exports